import i18next from 'i18next';
import { useResponseHandler } from 'utils/service/responseHandler';
import { apiClient } from 'utils';
import { DefaultError, useMutation, useQuery } from '@tanstack/react-query';
import { useQueryToast } from 'hooks';

interface RecoveryTwoFactorInput {
  email: string;
  code: string;
}

export const useRecoveryTwoFactor = () => {
    const { responseHandler } = useResponseHandler();
    const { loading, dismiss, success } = useQueryToast('useRecoveryTwoFactor');

    return useMutation<boolean, DefaultError, RecoveryTwoFactorInput>({
      mutationFn: async (body: RecoveryTwoFactorInput) => {
        loading(
          i18next.t('service-message.recovery-two-factor.loading', {
            what: i18next.t('user.what'),
          })
        );

        const response = await apiClient({
          method: 'POST',
          url: 'Auth/RecoveryTwoFactor',
          body: body,
        });

        return responseHandler(response, {
          groupName: `useRecoveryTwoFactor`,
        });
      },

      onSuccess: (data: any) =>
        success(
          i18next.t('service-message.recovery-two-factor.success', {
            what: i18next.t('user.what'),
          })
        ),
      onError: dismiss,
    });
  };
